import { useCallback, useEffect } from 'react';
import { FieldVerificationsContainer } from '../screens/SubmitRequest/FieldVerifications';
import { UseFormGetValues, UseFormTrigger } from 'react-hook-form';

export const useFieldVerificationInForm = ({
  getValues,
  validate,
}: {
  getValues: UseFormGetValues<Record<string, string>>;
  validate: UseFormTrigger<Record<string, string>>;
}) => {
  const { verifyField, fieldVerificationList, resetVerificationForField } = FieldVerificationsContainer.useContainer();

  const handleFieldVerify = useCallback(
    (allFieldValues: Record<string, string>) =>
      async ({ fieldName, fieldLabel }: { fieldName: string; fieldLabel: string }) => {
        await verifyField({
          fieldName,
          fieldLabel,
          fieldValues: { ...allFieldValues, ...getValues() },
        });

        // trigger validation after state be updated in FieldVerificationsContainer
        setTimeout(async () => {
          await validate(fieldName);
        }, 0);
      },
    [validate, getValues],
  );

  useEffect(
    () => () => {
      Object.keys(getValues()).forEach(fieldName => {
        resetVerificationForField(fieldName, '');
      });
    },
    [getValues],
  );

  return {
    handleFieldVerify,
    fieldVerificationList,
  };
};
